export const PROPERTY_CONSUMER_ID = {
  KEY: 'property_consumer_id',
  LABEL: 'Property Consumer ID',
  MAX_LENGTH: 50,
};
